module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Part-Title-1"
  }, [_vm._v("PART 1")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Epigraph"
  }, [_vm._v("“Our military and intelligence personnel go face to face with the world’s most dangerous men every day. They have risked their lives to capture some of the most brutal terrorists on earth and they have worked day and night to find out what the terrorists know so we can stop new attacks. America owes our brave men and women some things in return; we owe them thanks for saving lives and keeping America safe …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPigraph-2"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("RESIDENT")]), _vm._v(" G"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("EORGE")]), _vm._v(" W. B"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("USH")]), _vm._v(", S"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("EPTEMBER")]), _vm._v(" 6, 2006")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Epigraph"
  }, [_vm._v("“Sometimes people don’t want to hear the truth because they don’t want their illusions to be destroyed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPigraph-2"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("RIEDRICH")]), _vm._v(" N"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("IETZSCHE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f84fa252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part1.vue
// module id = 81
// module chunks = 0